"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelayedLoggerAdapter = void 0;
const constants_iso_1 = require("@wranggle/constants-iso");
const exceptions_1 = require("../exceptions");
const uid_util_1 = require("./uid-util");
class RelayedLoggerAdapter {
    constructor(args) {
        this._boundData = {};
        this._relayFn = args.relayFn;
        this._filterFn = args.filterFn;
        this._onCallbackError = args.onCallbackError;
        this.setLogLevel(args.logLevel || constants_iso_1.LogLevelName.Info);
        if (args.boundData) {
            this.bindData(args.boundData);
        }
    }
    trace(dataOrMsgOrFn, dataOrMsg) {
        this._sendLogCommand(constants_iso_1.LogLevelName.Trace, dataOrMsgOrFn, dataOrMsg);
    }
    debug(dataOrMsgOrFn, dataOrMsg) {
        this._sendLogCommand(constants_iso_1.LogLevelName.Debug, dataOrMsgOrFn, dataOrMsg);
    }
    info(dataOrMsgOrFn, dataOrMsg) {
        this._sendLogCommand(constants_iso_1.LogLevelName.Info, dataOrMsgOrFn, dataOrMsg);
    }
    warn(dataOrMsgOrFn, dataOrMsg) {
        this._sendLogCommand(constants_iso_1.LogLevelName.Warn, dataOrMsgOrFn, dataOrMsg);
    }
    error(dataOrMsgOrFn, dataOrMsg) {
        this._sendLogCommand(constants_iso_1.LogLevelName.Error, dataOrMsgOrFn, dataOrMsg);
    }
    fatal(dataOrMsgOrFn, dataOrMsg) {
        this._sendLogCommand(constants_iso_1.LogLevelName.Fatal, dataOrMsgOrFn, dataOrMsg);
    }
    logLevel() {
        return this._logLevelName;
    }
    setLogLevel(level) {
        this._logLevelName = level;
        this._logLevelValue = constants_iso_1.LogLevelValueByName[level];
    }
    bindData(data) {
        this._boundData = Object.assign(this._boundData, data);
    }
    getBoundData() {
        return Object.assign({}, this._boundData);
    }
    _sendLogCommand(logLevel, dataOrMsgOrFn, secondDataOrMsgParam) {
        let level = constants_iso_1.LogLevelValueByName[logLevel];
        if (level < this._logLevelValue) {
            return;
        }
        let stackHoldingLogLocation;
        if (level >= constants_iso_1.LogLevelValueByName[constants_iso_1.LogLevelName.Warn]) {
            stackHoldingLogLocation = (new Error('WantStackNotThrowing: stack at place of log command')).stack;
        }
        if (typeof dataOrMsgOrFn === 'function') {
            try {
                let delayed = dataOrMsgOrFn();
                delayed = Array.isArray(delayed) ? delayed : [delayed];
                dataOrMsgOrFn = delayed[0];
                secondDataOrMsgParam = delayed[1];
            }
            catch (err) {
                dataOrMsgOrFn = { error: (new exceptions_1.PlusPlusPlus(err, 'ErrorEvaluatingDelayedLoggingFunction')).toDataRecord() };
                stackHoldingLogLocation = undefined;
            }
        }
        let message;
        let data = this.getBoundData();
        [dataOrMsgOrFn, secondDataOrMsgParam].forEach(p => {
            if (typeof p === 'string') {
                if (message) {
                    data[`message.${uid_util_1.weakRandomChars()}`] = p;
                }
                else {
                    message = p;
                }
            }
            else if (typeof p === 'object') {
                data = Object.assign(data, p);
            }
        });
        if (stackHoldingLogLocation) {
            data.stackHoldingLogLocation = data.stackHoldingLogLocation || stackHoldingLogLocation;
        }
        let res = {
            logLevel, data, message
        };
        if (this._filterFn) {
            let modified;
            try {
                modified = this._filterFn(Object.assign({}, res));
            }
            catch (err) {
                this._callbackError(err);
            }
            if (modified === false) {
                level = 0;
            }
            else if (typeof modified === 'object' && modified.logLevel) {
                res = modified;
                if (modified.logLevel !== logLevel) {
                    level = constants_iso_1.LogLevelValueByName[modified.logLevel];
                }
            }
        }
        if (level >= this._logLevelValue) { // level might be modified by filterFn
            this._relayFn(res)
                .catch(err => {
                this._callbackError(err);
            });
        }
    }
    _callbackError(err) {
        if (this._onCallbackError) {
            try {
                this._onCallbackError(err);
            }
            catch (err) {
                console.warn('Failed to handle error in your callback', err);
            }
        }
        else {
            console.warn('Error in your callback', err);
        }
    }
}
exports.RelayedLoggerAdapter = RelayedLoggerAdapter;
// @types/pino uses:
// interface LogFn {
//   /* tslint:disable:no-unnecessary-generics */
//   <T extends object>(obj: T, msg?: string, ...args: any[]): void;
//   (msg: string, ...args: any[]): void;
// }
//# sourceMappingURL=relay-logger.js.map